import { withScreenDesignerContext } from "../../context";
import {
  
  ApplicationFooterItemComponentPreview as ApplicationFooterItemComponentPreviewDefinition,
} from "./ApplicationFooterItemComponentPreview";

export const ApplicationFooterItemComponentPreview = (withScreenDesignerContext(ApplicationFooterItemComponentPreviewDefinition));
